import { useSearch } from '@faststore/sdk'
import type { Product } from 'src/components/restructure/product/types/product'
import { useDiscountStripeContext } from 'src/components/contexts/DiscountStripeContext'
import { ProductStripe } from 'src/components/global/ProductStripe'
import { useMobile } from 'src/hooks/useMobile'

import { Pagination } from '../Pagination'
import GalleryPage from '../ProductGalleryPageV2'

interface ProductResultListV3Props {
  title: string
  totalProducts: number
  products?: Product[]
  registerPerPage: number
  type?: string
  page: number
}

function ProductResultListV3({
  title,
  products = [],
  totalProducts,
  registerPerPage,
  type,
  page,
}: Readonly<ProductResultListV3Props>) {
  const { isMobile } = useMobile()
  const { setPage, state } = useSearch()
  const { stripeData } = useDiscountStripeContext()

  const gridClasses =
    'product-grid product-grid-v3 grid gap-x-2 gap-y-8 sm:gap-[10px] md:gap-5 md:gap-y-10'

  const beforeStripe = stripeData && isMobile ? products.slice(0, 2) : []
  const afterStripe = stripeData && isMobile ? products.slice(2) : products

  return (
    <div className="product-listing__results product-listing__results--contained">
      {stripeData && isMobile && (
        <>
          <ul className={gridClasses}>
            <GalleryPage
              key={`gallery-page-before-${page}`}
              products={beforeStripe}
              page={page}
              title={title}
              totalCountOfRegisters={totalProducts}
              type={type}
            />
          </ul>

          <div className="w-full small:hidden mb-6 mt-3">
            <ProductStripe stripeData={stripeData} />
          </div>
        </>
      )}

      {!!afterStripe.length && (
        <ul className={gridClasses}>
          <GalleryPage
            key={`gallery-page-after-${page}`}
            products={afterStripe}
            page={page}
            title={title}
            totalCountOfRegisters={totalProducts}
            type={type}
          />
        </ul>
      )}

      <Pagination
        onPageChange={setPage}
        totalCountOfRegisters={totalProducts}
        currentPage={state.page === 0 ? 1 : state.page}
        registersPerPage={registerPerPage}
      />
    </div>
  )
}

export default ProductResultListV3
